"use strict";

exports.__esModule = true;
exports.DevicePropertyElement = DevicePropertyElement;
var _react = _interopRequireDefault(require("react"));
var _DeviceColorController = require("../../Device/DeviceColorSources/DeviceColorController");
var _DeviceContext = require("../../Device/DeviceContext");
var _TextValue = require("../../Measures/TextValue");
var _common = require("../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays a particular property of a device, e.g. name or uuid.
 */
function DevicePropertyElement(props) {
  var propertyName = props.propertyName;
  return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceColorController.DeviceColorController, _extends({
      deviceUuid: device.uuid
    }, (0, _common.getWidgetColorProps)(props)), function (_ref) {
      var color = _ref.color,
        backgroundColor = _ref.backgroundColor;
      return /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, _extends({
        value: device[propertyName],
        color: color,
        backgroundColor: backgroundColor
      }, (0, _common.getWidgetInteractionProps)(props), (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetInteractionProps)(props), {
        "data-testid": "DevicePropertyElement"
      }));
    });
  });
}